<div class="request-sidebar"> 
    <div class="section">
        <mat-accordion class="example-headers-align">
            <mat-expansion-panel expanded="true" class="one-panel">
                <mat-expansion-panel-header class="panel-header">
                  <mat-panel-title>
                    <div class="title">Người xét duyệt</div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="list">
                    <user-info-item *ngFor="let approver of approvers"
                                    [user]="approver" showApprovalStatus="true"></user-info-item>
                </div>
            </mat-expansion-panel>
        </mat-accordion>        
    </div>
    <div class="section">
        <mat-accordion class="example-headers-align">
            <mat-expansion-panel expanded="true" class="one-panel">
                <mat-expansion-panel-header class="panel-header">
                    <mat-panel-title>
                        <div class="title">Người theo dõi</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="list">
                    <user-info-item *ngFor="let follower of followers"
                                    [user]="follower" 
                                    [showOption]="follower.removable" 
                                    (remove)="onRemoveFollower(follower)"></user-info-item>
                </div>
            </mat-expansion-panel>
            <button mat-mini-fab class="add-more-follower" (click)="onAddFollower()">
                <mat-icon>add</mat-icon>
            </button>
        </mat-accordion>
    </div>
    <div class="section">
        <mat-accordion class="example-headers-align">
            <mat-expansion-panel expanded="true" class="one-panel">
                <mat-expansion-panel-header class="panel-header">
                  <mat-panel-title>
                    <div class="title">Hoạt động chính</div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="list">
                    <div class="activity-item" *ngFor="let activity of activities">
                        <div class="time" title="{{activity.createdDate.text}}"> 
                            <span class="d">{{activity.createdDate.date}}</span> <span class="h">{{activity.createdDate.time}}</span>
                        </div>
                        <div class="icon">
                            <mat-icon class="mati" [class]="activity.action">{{activity.statusIcon}}</mat-icon>
                        </div>
                        <div class="name"><b>{{activity.createdUser.fullName}}</b> {{activity.actionText}}</div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>